import styled, { css } from 'styled-components';

import Icon from '../ui/Icon';
import StyledLabel from '../ui/Form/Label';

import Text from '../ui/Text';
import { above } from '../../styles/libs';
import Link from '../ui/Link/Link';

export default styled.div`
  display: block;
  ${({ branded, theme }) => branded && css`
    padding: 0.5rem 2rem;
    background-color: ${theme.COLOR_BRAND_PRIMARY};
  `}
`;

export const Body = styled.section`
  padding: 1.25rem;

  ${({ theme, withBackground }) => withBackground && css`
    background-color: ${theme.COLOR_GRAY_LIGHTER};
  `}
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const Label = styled(StyledLabel)`
  margin-left: 1rem;
`;

export const CheckboxLabel = styled.label``;

export const CheckboxText = styled(Text)`
  margin-left: 1rem;
`;

export const TitleAndIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PitchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  gap: 1.25rem;
`;

export const NotAvailableText = styled(Text)`
  color: ${({ theme }) => theme.COLOR_BERRY_RED};
  font-weight: bold;
`;

export const ToggleButtonColumnContainer = styled.div`
  display: grid;
  column-gap: 0.5rem;
  grid-template-columns: 1fr 1fr;
  margin-top: 1rem;
`;

export const ToggleButton = styled.button`
  background-color: ${({ theme }) => theme.COLOR_GRAY_LIGHTEST};
  border: 2px solid ${({ selected, theme }) => (selected ? theme.COLOR_BRAND_PRIMARY : 'transparent')};
  border-radius: 5px;
  margin-top: 1rem;
  text-align: left;
  transition: all 250ms ease;
  width: 100%;
  outline: 0;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.COLOR_WHITE};
    cursor: default;
  }

  &:hover:not(:disabled) {
    border-color: ${({ selected, theme }) => (selected ? theme.COLOR_BRAND_PRIMARY : theme.COLOR_GRAY_LIGHT)};
  }
  /* stylelint-disable */
  ${ToggleButtonColumnContainer} > & + & {
    margin-left: 1rem;
  }
  /* stylelint-enable */
`;

export const ToggleBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem 1.125rem 0.5rem 0;
`;

export const ToggleContentContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
`;

export const ToggleContent = styled.div`
  flex: 0 1 100%;

  ${({ theme }) => above(theme.TABLET)`
    flex: 1;
  `}
  ${({ disabled }) => disabled && css`
    opacity: 0.5;
  `}
`;

export const ToggleTitle = styled(Text)`
  display: flex;
  width: 100%;
  font-size: 0.8125rem;
  font-weight: 600;
  ${({ disabled }) => disabled && css`
    opacity: 0.5;
  `}
`;

export const ToggleDescription = styled(Text)`
  font-size: 0.8125rem;
`;

export const ToggleSubTitle = styled(Text)`
  font-size: 0.8rem;
`;

export const LowAvailability = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.COLOR_CYAN_DARK};
  font-weight: bold;
  font-size: 0.8125rem; // 13px per designs
`;

export const LowAvailabilityIcon = styled(Icon)`
  font-size: 1rem;
`;

export const BookedMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.25rem;
  gap: 0.25rem;
  font-size: 0.8125rem; // 13px per designs
  font-weight: bold;
  color: ${({ theme }) => theme.COLOR_CYAN_DARK};
`;

export const BookedIcon = styled(Icon)`
  width: 16px;
  height: 16px;

  & > svg {
    fill: none;
  }
`;

export const PitchError = styled(Text)`
  font-size: 0.8125rem;
  line-height: 21px;
  color: ${({ theme }) => theme.COLOR_BERRY_RED};
  font-weight: bold;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const MembershipHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

export const MembershipTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const LoginLink = styled(Link)`
  color: ${({ theme }) => theme.COLOR_CYAN_DARK};
  font-weight: bold;
  text-decoration: underline;
`;

export const AvailabilityPitchesWrapper = styled.div``;

export const PartyFormWrapper = styled.div`
  margin-bottom: 0.5rem;
`;
